// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const MasterCustomerService = {};

MasterCustomerService.getPersonalCustomerTypeCodeList = function (data) {
  return lossClient({
    url: `/reference/personalcustomertype`,
    method: "get",
  });
};

MasterCustomerService.getGenderCustomerCodeList = function (data) {
  return lossClient({
    url: `/reference/gender`,
    method: "get",
  });
};

MasterCustomerService.getMaritalStatusCodeList = function (data) {
  return lossClient({
    url: `/reference/maritalstatus`,
    method: "get",
  });
};

MasterCustomerService.getReligionCodeList = function (data) {
  return lossClient({
    url: `/reference/religion`,
    method: "get",
  });
};

MasterCustomerService.getNationalityCodeList = function (data) {
  return lossClient({
    url: `/reference/nationality`,
    method: "get",
  });
};

MasterCustomerService.getCountryCodeList = function (data) {
  return lossClient({
    url: `/reference/countryid`,
    method: "get",
  });
};

MasterCustomerService.getEducationCodeList = function (data) {
  return lossClient({
    url: `/reference/rojkeducation`,
    method: "get",
  });
};

MasterCustomerService.getHomeStatusCodeList = function (data) {
  return lossClient({
    url: `/reference/homestatusid`,
    method: "get",
  });
};

MasterCustomerService.getSptTahunanCodeList = function (data) {
  return lossClient({
    url: `/reference/spttahunan`,
    method: "get",
  });
};

MasterCustomerService.getTypeOfWorkCodeList = function (data) {
  return lossClient({
    url: `/reference/typeofwork`,
    method: "get",
  });
};

MasterCustomerService.getWorkCodeList = function (data) {
  return lossClient({
    url: `/reference/kodePekerjaanId`,
    method: "get",
  });
};

MasterCustomerService.getBusinessEntityCodeList = function (data) {
  return lossClient({
    url: `/reference/badanUsahaId?pageIndex=0&pageSize=100`,
    method: "get",
  });
};

MasterCustomerService.getEconomySectorCodeList = function (data) {
  // console.log("getEconomySectorCodeList", data);
  var userInputIndex = data.pageIndex ?? 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;

  return lossClient({
    url: `/reference/rojkeconomisector?pageSize=${data?.pageSize}&pageIndex=${decrementIndex}&description=${data?.description}&code=${data?.code}`,
    method: "get",
  });
};

MasterCustomerService.getWorkFieldCodeList = function (data) {
  return lossClient({
    url: `/reference/bidangpekerjaanid?description=${data?.description}&code=${data?.code}`,
    method: "get",
  });
};

MasterCustomerService.getJobTitleCodeList = function (data) {
  return lossClient({
    url: `/reference/jabatanid`,
    method: "get",
  });
};

MasterCustomerService.getEmployeeStatusCodeList = function (data) {
  return lossClient({
    url: `/reference/statuspegawaiid`,
    method: "get",
  });
};

MasterCustomerService.getCompanyCategoryCodeList = function (data) {
  return lossClient({
    url: `/reference/companycategory`,
    method: "get",
  });
};

MasterCustomerService.getOfficeConditionCodeList = function (data) {
  return lossClient({
    url: `/reference/officecondition`,
    method: "get",
  });
};

MasterCustomerService.getRltnshpWithReporterCodeList = function (data) {
  var userInputIndex = data.pageIndex ?? 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url: `/reference/hubunganDenganPelapor?pageSize=${data?.pageSize}&pageIndex=${decrementIndex}&description=${data?.description}&code=${data?.code}`,
    method: "get",
  });
};

MasterCustomerService.getSourceIncomeCodeList = function (data) {
  return lossClient({
    url: `/reference/sourceincome`,
    method: "get",
  });
};

MasterCustomerService.getPropertySeparationAgreementCodeList = function (data) {
  return lossClient({
    url: `/reference/perjanjianpisahharta`,
    method: "get",
  });
};

MasterCustomerService.getMasterBankCodeList = function (data) {
  return lossClient({
    url: `/reference/masterBankId`,
    method: "get",
  });
};

MasterCustomerService.getMasterCreditCodeList = function (data) {
  return lossClient({
    url: `/reference/masterBankId`,
    method: "get",
  });
};

MasterCustomerService.getIDTypeCodeList = function (data) {
  return lossClient({
    url: `/reference/idtype`,
    method: "get",
  });
};

MasterCustomerService.getJobStatusCodeList = function (data) {
  return lossClient({
    url: `/reference/jobstatus`,
    method: "get",
  });
};

MasterCustomerService.getRltnshpWithCustomerCodeList = function (data) {
  return lossClient({
    url: `/reference/familyrelationship`,
    method: "get",
  });
};

MasterCustomerService.getInstitutionTypeCodeList = function (data) {
  return lossClient({
    url: `/reference/institutiontype`,
    method: "get",
  });
};

MasterCustomerService.getLoanTypeCodeList = function (data) {
  return lossClient({
    url: `/reference/loantype`,
    method: "get",
  });
};

MasterCustomerService.getThrdPrtyGrpCodeList = function (data) {
  var userInputIndex = data.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url: `/reference/rojkgolonganpihakketiga?pageSize=${data?.pageSize}&pageIndex=${decrementIndex}&description=${data?.description}&code=${data?.code}`,
    method: "get",
  });
};

MasterCustomerService.getCompanyStatusCodeList = function (data) {
  return lossClient({
    url: `/reference/companystatus`,
    method: "get",
  });
};

MasterCustomerService.getOfficeStatusCodeList = function (data) {
  return lossClient({
    url: `/reference/officestatus`,
    method: "get",
  });
};

MasterCustomerService.getLegalDocumentCodeList = function (data) {
  return lossClient({
    url: `/reference/legaldocument`,
    method: "get",
  });
};

MasterCustomerService.getJobPositionCodeList = function (data) {
  return lossClient({
    url: `/reference/rojkJabatan?pageSize=100&pageIndex=0`,
    method: "get",
  });
};

MasterCustomerService.getBusinessRiskCodeList = function (data) {
  return lossClient({
    url: `/reference/businessrisk`,
    method: "get",
  });
};

MasterCustomerService.getEnvSocialRiskCodeList = function (data) {
  return lossClient({
    url: `/reference/envsocialrisk`,
    method: "get",
  });
};

MasterCustomerService.getBankAccountTypeList = function (data) {
  return lossClient({
    url: `/reference/bankaccounttype`,
    method: "get",
  });
};

export default MasterCustomerService;
